import React from 'react';
import { type TimelineEvent } from '@/hooks/useTimelineDecisoes';
import { ArrowRightLeft, CheckCircle2, FileText, AlertTriangle } from 'lucide-react';

interface Props {
  events: TimelineEvent[];
  totalLoaded: number;
}

export const TimelineStats: React.FC<Props> = ({ events, totalLoaded }) => {
  const transicoes = events.filter(e => e.tipo === 'transicao').length;
  const aprovacoes = events.filter(e => e.tipo === 'aprovacao').length;
  const auditorias = events.filter(e => e.tipo === 'auditoria').length;
  const criticos = events.filter(e => e.is_critical).length;

  const stats = [
    { label: 'Eventos', value: totalLoaded, icon: null },
    { label: 'Transições', value: transicoes, icon: ArrowRightLeft, color: 'text-amber-400' },
    { label: 'Aprovações', value: aprovacoes, icon: CheckCircle2, color: 'text-emerald-400' },
    { label: 'Auditoria', value: auditorias, icon: FileText, color: 'text-blue-400' },
    { label: 'Críticos', value: criticos, icon: AlertTriangle, color: 'text-red-400' },
  ];

  return (
    <div className="flex items-center gap-4 text-xs text-muted-foreground px-1 flex-wrap">
      {stats.map(s => (
        <span key={s.label} className="flex items-center gap-1">
          {s.icon && <s.icon className={`w-3 h-3 ${s.color}`} />}
          <span className="font-medium text-foreground">{s.value}</span> {s.label}
        </span>
      ))}
    </div>
  );
};
